/* Injects Duals Natural review stars (.dn-stars, styled in duals-design.css)
   into Doofinder search-layer product cards. Rating data comes from
   dn-ratings.js (window.DN_RATINGS = { handle: [avg, count] }), generated
   from Loox metafields — regenerate it when reviews change meaningfully. */
(function () {
  'use strict';
  var loaded = false;

  function loadRatings(cb) {
    if (window.DN_RATINGS) return cb();
    if (loaded) return;
    loaded = true;
    var s = document.createElement('script');
    s.src = window.DN_RATINGS_URL;
    s.onload = cb;
    document.head.appendChild(s);
  }

  function starsEl(avg, count) {
    var pct = Math.min(avg * 20, 100);
    var span = document.createElement('span');
    span.className = 'dn-stars';
    span.setAttribute('role', 'img');
    span.setAttribute('aria-label', 'Rated ' + avg + ' out of 5 stars from ' + count + ' review' + (count > 1 ? 's' : ''));
    span.innerHTML =
      '<span class="dn-stars__track" aria-hidden="true">' +
        '<span class="dn-stars__fill" style="width:' + pct + '%">★★★★★</span>' +
        '<span class="dn-stars__base">★★★★★</span>' +
      '</span>' +
      '<span class="dn-stars__count" aria-hidden="true">(' + count + ')</span>';
    return span;
  }

  function decorate(root) {
    var cards = (root || document).querySelectorAll('.dfd-card:not([data-dn-stars])');
    if (!cards.length) return;
    loadRatings(function () {
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        card.setAttribute('data-dn-stars', '1');
        var link = card.querySelector('a[href*="/products/"]');
        var title = card.querySelector('.dfd-card-title');
        if (!link || !title) continue;
        var handle = (link.getAttribute('href').split('/products/')[1] || '').split('?')[0].split('#')[0];
        var r = window.DN_RATINGS && window.DN_RATINGS[handle];
        if (!r) continue;
        title.insertAdjacentElement('afterend', starsEl(r[0], r[1]));
      }
    });
  }

  var watching = false;
  function watchLayer() {
    if (watching) return;
    watching = true;
    var mo = new MutationObserver(function () { decorate(document); });
    mo.observe(document.body, { childList: true, subtree: true });
    decorate(document);
  }

  // Start watching only once the Doofinder layer exists, so the observer
  // isn't running on pages where search is never opened.
  if (document.querySelector('.dfd-root')) {
    watchLayer();
  } else {
    var boot = new MutationObserver(function () {
      if (document.querySelector('.dfd-root')) {
        boot.disconnect();
        watchLayer();
      }
    });
    boot.observe(document.body, { childList: true, subtree: true });
  }
})();
